import Drawer from "devextreme-react/drawer";
import PropTypes from "prop-types";
import React, { useState } from "react";
import SidePanelContent from "./SidePanelContent";
import "./SidePanelDrawer.scss";

const SidePanelDrawer = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const sidePanelContent = () => (
    <SidePanelContent isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
  );

  return (
    <Drawer
      opened={isDrawerOpen}
      openedStateMode="overlap"
      position="left"
      revealMode="expand"
      height="100vh"
      visible={true}
      minSize={50}
      maxSize={173}
      component={sidePanelContent}
      elementAttr={{ id: "sidepaneldrawer-block", class: "partner-portal-sidepanel" }}
      closeOnOutsideClick={() => setIsDrawerOpen(false)}
    >
      {children}
    </Drawer>
  );
};

SidePanelDrawer.propTypes = {
  children: PropTypes.node,
};

SidePanelDrawer.defaultProps = {
  children: undefined,
};

export default SidePanelDrawer;
